module.exports = __webpack_public_path__ + "img/ics_o_clock2.4624110d.svg";